import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";
import { IBFRecord } from "@/lib/drivers/insulet/IBFRecords/IBFRecord";

export type IBFBasalRate = {
  basalRate: number;
  duration: number;
  percentage: number;
};

export const IBF_BASAL_RATE = {
  value: 0x0008,
  name: "IBF_BASAL_RATE",
  size: 8,
  parse: (record: IBFRecord): IBFBasalRate => {
    const basalRate = record.nextUInt32LE() / 100.0;
    const duration = record.nextUInt16LE() * 60 * 1000;
    const percentage = 1 + record.nextInt16LE() / 100.0;

    return {
      basalRate,
      duration,
      percentage,
    };
  },
} as const satisfies IBFHistoryRecordDefinition<IBFBasalRate>;
